import React from "react";
import { Link } from "react-router-dom";
import { convertStoMs } from "../functions/convertStoMs";
import useAuth from "../hooks/useAuth";
import { Alert } from "@mui/material";

export default function Logo() {
  const { auth } = useAuth();

  return (
    <>
      <section className="logo">
        <div className="container">
          <div className="content">
            <div className="region-logo row align-items-center">
              <div className="col-12 col-sm-2 text-center text-sm-start mb-2 mb-sm-0">
                <Link to={'/'} title="iStore Wholesale" alt="iStore Wholesale Homepage">
                  <img
                    className="img-fluid"
                    style={{ maxWidth: '120px' }}
                    src="/assets/images/istore-logo.png"
                    alt="iStore Wholesale Logo"
                  />
                </Link>
              </div>
              <div className="col-12 col-sm-10 text-center text-sm-end">
                <span className="d-none d-sm-inline">
                  Session Expires: {(new Date(auth.exp * 1000)).toLocaleTimeString()} ({convertStoMs(((auth.exp - (Date.now() / 1000))))})
                </span>
                <span className="d-inline d-sm-none small">
                  Session Expires: {(new Date(auth.exp * 1000)).toLocaleTimeString()}
                </span>
              </div>
            </div>
          </div>
          {auth?.stop_credit && (
            <Alert severity="error" sx={{ mt: 2, mb: 0 }}>
              <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                <div style={{ minWidth: 'fit-content', marginRight: '12px' }}>
                  <strong>Account Notice:</strong>
                </div>
                <div style={{ flex: 1 }}>
                  Our records show that there is an outstanding balance on your account. This is preventing you from creating new orders.
                  Please call the office on <strong>08 9203 1272</strong> to finalise your outstanding balance.
                </div>
              </div>
            </Alert>
          )}
        </div>
      </section>
    </>
  );
}